@if (showBar) {
  <div class="progress rounded-0" [ngClass]="{'progress-even-rows' : rowNumber % 2 === 0, 'progress-odd-rows' : rowNumber % 2 !== 0}">
    <div class="progress-bar" role="progressbar" [style.width]="value + '%'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
      @if (value < compareWith) {
        <div [style.margin-left]="(value + 50)+'%'">
          <div class="progress-value text-primary" style="margin-left: 10px">
            {{value | number: '1.1-1' | customNumberFormat }}%
          </div>
        </div>
      }
      @if (value >= compareWith) {
        <div>
          <div [class]="'progress-value ' + (theme$ | async) === eThemeName.LIGHT ? '' : 'text-black'">
            {{value | number: '1.1-1' | customNumberFormat }}%
          </div>
        </div>
      }
    </div>
  </div>
}
